import * as IoC from 'typescript-ioc';
import * as mobx from 'mobx';
import { JobDtoType } from '../index';
import { IJobsDAO } from '../../../api/jobs.dao';
import { ExecutionState } from '../execution-state';
import { JobExecutionRunner } from './job-execution-runner';

export class EventExecutionState extends ExecutionState <JobDtoType, JobExecutionRunner> {
    private readonly jobsDao: IJobsDAO = IoC.Container.get(IJobsDAO);

    @mobx.observable
    private state = null;

    @mobx.action.bound
    private clearState(): void {
        this.state.clear();
    }

    constructor() {
        super();
        this.state = new Map();
    }

    @mobx.action.bound
    public addToState(jobExecution: JobDtoType): void {
        this.state.set(jobExecution.jobId, JobExecutionRunner.create(jobExecution));
    }

    @mobx.action.bound
    public removeFromState(jobExecutionId: number): void {
        this.state.delete(jobExecutionId);
    }

    @mobx.action.bound
    public setState(jobsExecutions: JobDtoType[]) {
        this.state.clear();
        jobsExecutions.forEach(jobExec => this.addToState(jobExec));
    }

    public getState(): JobExecutionRunner[] {
        return [ ...this.state.values() ];
    }

    @mobx.action
    public async initState(): Promise<void> {
        try {
            const jobsExecutions = await this.jobsDao.getAllJobsTriggeredByCurrentUser() as JobDtoType[];
            mobx.runInAction(() => this.setState(jobsExecutions));
        } catch {
            mobx.runInAction(this.clearState);
        }
    }
}
